export default __webpack_public_path__ + "./fonts/pyg.b8464637.svg";